import script from "./NewsPagePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPagePagination.vue?vue&type=script&setup=true&lang=js"

import "./NewsPagePagination.vue?vue&type=style&index=0&id=72ff7b8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ff7b8e"]])

export default __exports__